export type DateWindow = {
  start: string;
  end: string;
};

export const getDateWindow = (ranges: DateWindow[]): DateWindow | null => {
  if (ranges.length === 0) return null;

  return ranges.reduce<DateWindow>(
    (acc, range) => ({
      start: range.start < acc.start ? range.start : acc.start,
      end: range.end > acc.end ? range.end : acc.end,
    }),
    {
      start: ranges[0]?.start ?? '',
      end: ranges[0]?.end ?? '',
    }
  );
};

export const hasDateOverlap = (
  start: string,
  end: string,
  dateWindow: DateWindow
): boolean => start <= dateWindow.end && end >= dateWindow.start;
